import { gql } from "@apollo/client";
import { ApolloClientQuery } from "./_setup";

const TOTP_FIELDS = `
    _id
    status
    name
    confirmedAt
    lastUsedAt
    lockedAt
    createdAt
`;

const GET_USER_TOTP = gql`
    query getUserTotp {
        getUserTotp {
            ... on UserTotpState {
                available
                authenticator {
                    ${TOTP_FIELDS}
                }
            }
            ... on BaseError {
                errKey
                errMsg
            }
        }
    }
`;

export async function getUserTotpQuery() {
    return await ApolloClientQuery(GET_USER_TOTP, {}, false, "no-cache");
}

const START_TOTP_ENROLMENT = gql`
    mutation startTotpEnrolment($input: TotpEnrolmentInput) {
        startTotpEnrolment(input: $input) {
            ... on TotpEnrolment {
                otpauthUrl
                secret
                issuer
                accountName
                expiresAt
                attemptsRemaining
            }
            ... on BaseError {
                errKey
                errMsg
                errObj
            }
        }
    }
`;

export async function startTotpEnrolmentMutation(twoFactorChallengeId) {
    return await ApolloClientQuery(
        START_TOTP_ENROLMENT,
        { input: { twoFactorChallengeId } },
        true,
    );
}

const CONFIRM_TOTP_ENROLMENT = gql`
    mutation confirmTotpEnrolment($code: String!) {
        confirmTotpEnrolment(code: $code) {
            ... on UserTotp {
                ${TOTP_FIELDS}
            }
            ... on BaseError {
                errKey
                errMsg
                errObj
            }
        }
    }
`;

export async function confirmTotpEnrolmentMutation(code) {
    return await ApolloClientQuery(CONFIRM_TOTP_ENROLMENT, { code }, true);
}

const REVOKE_USER_TOTP = gql`
    mutation revokeUserTotp($twoFactorChallengeId: String) {
        revokeUserTotp(twoFactorChallengeId: $twoFactorChallengeId) {
            ... on UserTotp {
                _id
                status
            }
            ... on BaseError {
                errKey
                errMsg
                errObj
            }
        }
    }
`;

export async function revokeUserTotpMutation(twoFactorChallengeId) {
    return await ApolloClientQuery(REVOKE_USER_TOTP, { twoFactorChallengeId }, true);
}
